import React, { FC } from 'react'

import { EntityPickerIcon, EntityEditIcon, WidgetContainer, WidgetInputContainer } from '../widget-styles'
import { UnitPickerInput } from './styles'

type Props = {
    selectedUnitName?: string
    scrollToEntitySection: () => void
}

const UnitPicker: FC<Props> = ({ selectedUnitName, scrollToEntitySection }) => {
    return (
        <WidgetContainer>
            <WidgetInputContainer>
                <EntityPickerIcon />
                <UnitPickerInput value={selectedUnitName}></UnitPickerInput>
                <EntityEditIcon onClick={scrollToEntitySection} />
            </WidgetInputContainer>
        </WidgetContainer>
    )
}

export default UnitPicker
